module.exports = [
  {
    "id": 48,
    "title": {
      "rendered": "drinks"
    },
    "menu_order": 0,
    "acf": {
      "sections": [
        {
          "section_title": "coffee & tea",
          "items": false,
          "section_uuid": "1530244123506",
          "section_isRecurring": true,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [
            {
              "price": "12oz"
            },
            {
              "price": "16oz"
            }
          ],
          "subsections": [
            {
              "subsection_title": "",
              "items": [
                {
                  "item_title": "brewed coffee",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2"
                    },
                    {
                      "price": "2.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533061080490",
                  "item_isSpecial": false
                },
                {
                  "item_title": "house chai (iced or hot)",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3"
                    },
                    {
                      "price": "3.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "15311233246789",
                  "item_isSpecial": false
                },
                {
                  "item_title": "cold brew iced coffee",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2.5"
                    },
                    {
                      "price": "2.75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065007356",
                  "item_isSpecial": false
                },
                {
                  "item_title": "hot tea",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2"
                    },
                    {
                      "price": "2"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182422620",
                  "item_isSpecial": false
                },
                {
                  "item_title": "iced tea",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2"
                    },
                    {
                      "price": "2.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065026308",
                  "item_isSpecial": false
                },
                {
                  "item_title": "espresso",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2.75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065047278",
                  "item_isSpecial": false
                },
                {
                  "item_title": "latte",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1532473674392",
                  "item_isSpecial": false
                },
                {
                  "item_title": "cappuccino",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1532473690446",
                  "item_isSpecial": false
                },
                {
                  "item_title": "americano",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "2.75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1532473691000",
                  "item_isSpecial": false
                },
                {
                  "item_title": "macchiato",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.25"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533064853308",
                  "item_isSpecial": false
                },
                {
                  "item_title": "mocha",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "4"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182534378",
                  "item_isSpecial": false
                },
                {
                  "item_title": "iced latte",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182537215",
                  "item_isSpecial": false
                },
                {
                  "item_title": "iced mocha",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "4"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182537650",
                  "item_isSpecial": false
                },
                {
                  "item_title": "spicy mocha\n(hot or iced)",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "4"
                    },
                    {
                      "price": "4.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534183180428",
                  "item_isSpecial": true
                },
                {
                  "item_title": "soy or almond milk",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": ".75"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182538267",
                  "item_isSpecial": false
                },
                {
                  "item_title": "extra shot",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "1.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182538677",
                  "item_isSpecial": false
                }
              ],
              "subsection_uuid": "1533065475837",
              "subsection_notes": "",
              "subsection_price_columns": []
            }
          ]
        },
        {
          "section_title": "house-made juices",
          "items": false,
          "section_uuid": "1531247160610",
          "section_isRecurring": false,
          "section_notes": "",
          "section_columns": [
            {
              "column_title": ""
            }
          ],
          "section_price_columns": [],
          "subsections": [
            {
              "subsection_title": "cold-pressed organic",
              "items": [
                {
                  "item_title": "abc",
                  "item_description": "apple, carrot, beet, lemon",
                  "item_prices": [
                    {
                      "price": "6"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1531247162456",
                  "item_isSpecial": false
                },
                {
                  "item_title": "popeye",
                  "item_description": "spinach, lemon, kale, apple",
                  "item_prices": [
                    {
                      "price": "11"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1531247165423",
                  "item_isSpecial": false
                },
                {
                  "item_title": "green drink",
                  "item_description": "apple, fennel, kale, cucumber, celery",
                  "item_prices": [
                    {
                      "price": "7"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "153124716754361",
                  "item_isSpecial": false
                },
                {
                  "item_title": "sweet tart",
                  "item_description": "apple, carrot, beet, lemon, ginger",
                  "item_prices": [
                    {
                      "price": "5.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533067131460",
                  "item_isSpecial": false
                },
                {
                  "item_title": "the cleanser",
                  "item_description": "beet, fennel, cucumber, lemon, celery",
                  "item_prices": [
                    {
                      "price": "7"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534182639715",
                  "item_isSpecial": false
                },
                {
                  "item_title": "immune booster",
                  "item_description": "orange, grapefruit, fennel, apple with grapefruit seed extract",
                  "item_prices": [
                    {
                      "price": "6"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533067055489",
                  "item_isSpecial": false
                },
                {
                  "item_title": "calcium injection",
                  "item_description": "cucumber, kale, celery, lemon, ginger, parsley",
                  "item_prices": [
                    {
                      "price": "7.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533067019477",
                  "item_isSpecial": false
                }
              ],
              "subsection_uuid": "1533065477366",
              "subsection_notes": "",
              "subsection_price_columns": []
            },
            {
              "subsection_title": "cold-pressed shots",
              "items": [
                {
                  "item_title": "wellness (2oz)",
                  "item_description": "ginger, lemon, cayenne",
                  "item_prices": [
                    {
                      "price": "4"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065567225",
                  "item_isSpecial": false
                },
                {
                  "item_title": "ginger (1oz)",
                  "item_description": "apple, carrot, beet, lemon",
                  "item_prices": [
                    {
                      "price": "2"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065689640",
                  "item_isSpecial": false
                },
                {
                  "item_title": "wheatgrass (1.5oz)",
                  "item_description": "apple, carrot, beet, lemon",
                  "item_prices": [
                    {
                      "price": "3"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065703544",
                  "item_isSpecial": false
                }
              ],
              "subsection_uuid": "1533065556680",
              "subsection_notes": "",
              "subsection_price_columns": []
            },
            {
              "subsection_title": "fresh squeezed juices",
              "items": [
                {
                  "item_title": "organic orange juice",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "4"
                    },
                    {
                      "price": "5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533067031647",
                  "item_isSpecial": false
                },
                {
                  "item_title": "beet lemonade",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.5"
                    },
                    {
                      "price": "4.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533065582628",
                  "item_isSpecial": true
                },
                {
                  "item_title": "pineapple ginger\nlimeade",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "3.5"
                    },
                    {
                      "price": "4.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1533067027978",
                  "item_isSpecial": true
                },
                {
                  "item_title": "watermelon lemonade",
                  "item_description": "",
                  "item_prices": [
                    {
                      "price": "4"
                    },
                    {
                      "price": "4.5"
                    }
                  ],
                  "item_addons": false,
                  "item_uuid": "1534183143262",
                  "item_isSpecial": true
                }
              ],
              "subsection_uuid": "1533065569447",
              "subsection_notes": "",
              "subsection_price_columns": [
                {
                  "price": "12oz"
                },
                {
                  "price": "16oz"
                }
              ]
            }
          ]
        }
      ],
      "last_save_timestamp": "1534184562",
      "is_drinks_menu": true
    }
  },
  {
    "id": 38,
    "title": {
      "rendered": "break\nfast"
    },
    "menu_order": 1,
    "acf": {
      "sections": [
        {
          "section_title": "breakfast sandwiches",
          "items": [
            {
              "item_title": "bacon, egg, and cheese sandwich",
              "item_description": "Nueske's bacon, sharp cheddar, & scrambled egg on a biscuit",
              "item_addons": [
                {
                  "addon_title": "on croissant, toast, or bagel",
                  "addon_price": "+1",
                  "addon_uuid": "1534183679893"
                }
              ],
              "item_uuid": "1534183578593",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "5.5"
                }
              ]
            },
            {
              "item_title": "avocado toast",
              "item_description": "one egg, sliced avocado, fresh basil, shaved radish, lemon zest & olive oil on wheat OR sourdough",
              "item_addons": false,
              "item_uuid": "1534183828208",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "7"
                }
              ]
            },
            {
              "item_title": "green sandwich",
              "item_description": "one egg, baby arugula, tomato, avocado mash & swiss on choice of toast, bagel, or croissant",
              "item_addons": false,
              "item_uuid": "1534183865703",
              "item_isSpecial": true,
              "item_prices": [
                {
                  "price": "7.5"
                }
              ]
            },
            {
              "item_title": "green eggs & ham",
              "item_description": "scrambled egg w/pesto, red onion, shaved ham & melted swiss on croissant",
              "item_addons": false,
              "item_uuid": "1534183923072",
              "item_isSpecial": true,
              "item_prices": [
                {
                  "price": "7.5"
                }
              ]
            }
          ],
          "section_uuid": "1530133075883",
          "section_isRecurring": false,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        },
        {
          "section_title": "daily specials",
          "items": [
            {
              "item_title": "today's quiche",
              "item_description": "turkey breast, provolone, roasted red peppers",
              "item_addons": false,
              "item_uuid": "1531247091064",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "3.25"
                }
              ]
            },
            {
              "item_title": "pancake special",
              "item_description": "ginger & nutmeg spiced with roasted banana",
              "item_addons": [
                {
                  "addon_title": "or buttermilk",
                  "addon_price": "5.5",
                  "addon_uuid": "1534183059923"
                }
              ],
              "item_uuid": "1531247095325",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "6"
                }
              ]
            },
            {
              "item_title": "scramble special",
              "item_description": "3 eggs, sautéed zucchini & onion, roasted jalapeño, provolone\nw/sourdough OR wheat toast\n",
              "item_addons": false,
              "item_uuid": "1534183112358",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "8.5"
                }
              ]
            }
          ],
          "section_uuid": "1530572033674",
          "section_isRecurring": true,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        },
        {
          "section_title": "plates",
          "items": [
            {
              "item_title": "satsuma breakfast plate",
              "item_description": "2 eggs, creamy black beans, bacon, fresh fruit & toast OR biscuit",
              "item_addons": false,
              "item_uuid": "1531261125563",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            },
            {
              "item_title": "mexican breakfast plate",
              "item_description": "cream black beans, cotija cheese, pico de gallo, avocado slices and 2 eggs w/corn tortilla",
              "item_addons": [
                {
                  "addon_title": "w/slow roasted pork",
                  "addon_price": "12",
                  "addon_uuid": "1534183745374"
                }
              ],
              "item_uuid": "1534183642008",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            },
            {
              "item_title": "granola, fruit & yogurt",
              "item_description": "housemade granola, fresh fruit & organic yogurt topped w/honey",
              "item_addons": false,
              "item_uuid": "1534183963188",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "7"
                }
              ]
            },
            {
              "item_title": "vegan curry scramble",
              "item_description": "quinoa OR tofu w/roasted cauliflower, kale & sweet potatoes with a coconut-ginger curry and sourdough bread",
              "item_addons": false,
              "item_uuid": "1534184013103",
              "item_isSpecial": true,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            }
          ],
          "section_uuid": "1534183533095",
          "section_isRecurring": false,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        }
      ],
      "last_save_timestamp": "1534223548"
    }
  },
  {
    "id": 45,
    "title": {
      "rendered": "lunch"
    },
    "menu_order": 2,
    "acf": {
      "sections": [
        {
          "section_title": "salads",
          "items": [
            {
              "item_title": "market vegetable salad",
              "item_description": "raw market vegetables, arugula, avocado & sunflower seeds w/preserved citrus vinaigrette",
              "item_addons": false,
              "item_uuid": "1534184189006",
              "item_isSpecial": true,
              "item_prices": [
                {
                  "price": "9"
                }
              ]
            },
            {
              "item_title": "mediterranean quinoa salad",
              "item_description": "chickpeas, spinach, cherry tomatoes, kalamata olives, feta, red onion & basil w/lemon vinaigrette & hummus crouton",
              "item_addons": false,
              "item_uuid": "1534184419074",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "10"
                }
              ]
            },
            {
              "item_title": "the kale salad",
              "item_description": "lacinato kale, spinach, hard-boiled egg, cherry tomatoes, bacon, avocado slices, basil & parmesan croutons w/creamy garlic dressing",
              "item_addons": false,
              "item_uuid": "1534184484703",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "10.5"
                }
              ]
            }
          ],
          "section_uuid": "1530242146785",
          "section_isRecurring": false,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        },
        {
          "section_title": "menu 4 section 2s",
          "items": [
            {
              "item_title": "hash of the day",
              "item_description": "roasted potato, red gravy with bacon & okra. 2 eggs any style w/toast OR biscuit",
              "item_addons": false,
              "item_uuid": "",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            },
            {
              "item_title": "salad bowl",
              "item_description": "Israeli couscous, thyme, sesama chicken, cucumber, red bell pepper, arugula, balsamic vinaigrette",
              "item_addons": false,
              "item_uuid": "1534183418638",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            }
          ],
          "section_uuid": "1531261261652",
          "section_isRecurring": true,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        },
        {
          "section_title": "lunch sandwiches",
          "items": [
            {
              "item_title": "special BLT",
              "item_description": "nueske's bacon, tomato, avocado mash, whipped goat cheese & arugula on sourdough OR wheat",
              "item_addons": false,
              "item_uuid": "1534184190411",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9"
                }
              ]
            },
            {
              "item_title": "turkey",
              "item_description": "shaved all-natural turkey breast, pesto aioli, roasted red peppers, provolone & arugula on ciabatta",
              "item_addons": false,
              "item_uuid": "1534184219762",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "10"
                }
              ]
            },
            {
              "item_title": "grilled cheese",
              "item_description": "sharp cheddar or baby swiss w/tomato on sourdough OR wheat",
              "item_addons": false,
              "item_uuid": "1534184242963",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "6"
                }
              ]
            },
            {
              "item_title": "satsuma cuban",
              "item_description": "shaved ham, slow-roasted pork, creole mustard, aioli, swiss cheese & housemad pickles on ciabatta",
              "item_addons": false,
              "item_uuid": "1534184247286",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "10.5"
                }
              ]
            },
            {
              "item_title": "black bean burger",
              "item_description": "brown rice, beet & black bean patty, romesco, spinach & avocado mash on sourdough OR wheat",
              "item_addons": false,
              "item_uuid": "1534184251740",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "9.5"
                }
              ]
            },
            {
              "item_title": "hummus veggie wrap",
              "item_description": "hummus, spinach, cherry tomato, cucumber, red cabbage slaw & toum on spinach wrap",
              "item_addons": false,
              "item_uuid": "1534184256863",
              "item_isSpecial": false,
              "item_prices": [
                {
                  "price": "8.5"
                }
              ]
            }
          ],
          "section_uuid": "1534184146064",
          "section_isRecurring": false,
          "section_notes": "",
          "section_columns": false,
          "section_price_columns": [],
          "subsections": false
        }
      ],
      "last_save_timestamp": "1534184569"
    }
  }
]


// WEBPACK FOOTER //
// ./src/components/testMenusData.js